<div class="p-5">
  <app-new-password [user]="authUser"></app-new-password>
</div>
